module.exports = __webpack_public_path__ + "img/app_code.6ae59d13.jpg";